import styled from 'styled-components';

export const Wrapper = styled.div`
  background-color: #142c43;
  text-align: center;
  height: 100vh;
`;

export const Logo = styled.img`
  margin-top: 20px;
  max-width: 100%;
`;
